import { getUrlWithProtocol } from '@bbl-digital/snorre-v2'

/**
 * Function to check if parent path is active
 *
 * @param path items path
 * @param locationPath location path
 */
export const isActiveParent = (path: string, locationPath: string) => {
  if (path === '/') {
    return path === locationPath
  } else {
    return locationPath.indexOf(path) !== -1
  }
}

/**
 * Function to check if path is active
 * Logic because we have exclude base paths
 *
 * @param path items path
 * @param locationPath location path
 */
export const isActivePath = (path: string, locationPath: string) => {
  const pathNumberOfSlashes = path.split('/').length - 1
  const numberOfSlashes = locationPath.split('/').length - 1
  if (numberOfSlashes >= 1 && numberOfSlashes <= 3) {
    return (
      path === locationPath ||
      // fix to keep "locationPath" active while on child path"
      isExceptionInPathConditions(locationPath, path)
    )
  } else if (pathNumberOfSlashes === 1) {
    return false
  } else {
    return locationPath.indexOf(path) !== -1
  }
}

// Exception paths that should be active when child path is active
const exceptionPaths = [
  { locationPath: '/okonomi/budsjettmobil', path: '/okonomi/budsjett' },
]

const isExceptionInPathConditions = (locationPath: string, path: string) => {
  return exceptionPaths.some(
    (exceptionPath) =>
      exceptionPath.locationPath === locationPath && exceptionPath.path === path
  )
}

export const getPreemptionUrl = () => {
  if (window.config.bblCode === 'sbbl') {
    return window.config.urls.forkjopUrl + 'bosor'
  }
  return window.config.urls.forkjopUrl + window.config.bblCode
}

export const getOldPortalUrl = () => {
  let bblCodeFromConfig = window.config.bblCode.toLowerCase()

  if (bblCodeFromConfig === 'rjukantinn') {
    bblCodeFromConfig = 'rtbbl'
  }
  return `${getUrlWithProtocol(bblCodeFromConfig)}.${
    window.config.urls.oldPortalUrl
  }`
}

export const getAppDeeplink = () => {
  return window.config.bblCode.toLowerCase() + '.ngtapp://'
}
